





























import $http from "axios";
import Configuration from "front-component/Configuration";
import Auth from "front-component/Auth";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { ImpersonationUser } from "@/modules/ImpersonationUser";

@Component
export default class SwitchUser extends Vue {
    @Prop() public currentUser!: any;

    @Action("fetchImpersonationUsers")
    public fetchImpersonationUsers!: (search: string) => Promise<ImpersonationUser[]>;
    @Getter("getImpersonationUsers") public getImpersonationUsers!: ImpersonationUser[];
    @Mutation("setImpersonationUsers") public setImpersonationUsers!: (users: ImpersonationUser[]) => void;
    public impersonatedUser: ImpersonationUser | null = null;
    public visible: boolean = false;
    public loading: boolean = false;

    private getUserIdByEmail(email: string): Promise<any> {
        return $http.request(
            {
                headers: {
                    Authorization: `Bearer ${Auth.getAccessToken()}`
                },
                url: `${Configuration.get("authUri")}/users/${email}/userId`,
                method: "get",
            }
        ).then((response) => {
            return response.data;
        });
    }

    private searchUser(query: string): void {
        if (!query) { this.setImpersonationUsers([]); }
        if (query.length < 3) { return; }
        this.loading = true;
        this.fetchImpersonationUsers(query).then(() => {
            this.loading = false;
        });
    }

    private createSwitchToken(userId: string, applicationId: string): Promise<any> {
        return $http.request(
            {
                headers: {
                    Authorization: `Bearer ${Auth.getAccessToken()}`
                },
                url: `${Configuration.get("authUri")}/tokens/switch-user`,
                method: "post",
                data: {
                    userId,
                    applicationId
                }
            }
        ).then((response) => {
            return response.data;
        });
    }

    private async switchUserImpersonate(targetedUser: ImpersonationUser): Promise<void> {
        const user: { userId: string } = await this.getUserIdByEmail(targetedUser.username);
        const token = await this.createSwitchToken(user.userId, "cockpit-id");
        const tokenUser = Auth.getAccessToken();

        if (!token) { return; }
        if (tokenUser) { localStorage.setItem("access_token_admin", tokenUser); }

        localStorage.setItem("admin_user", this.currentUser ? this.currentUser.displayName as string : "");
        Auth.setAccessToken(token);
        location.reload();
    }

    private resetImpersonationUsers() {
        this.setImpersonationUsers([]);
    }

    private switchUser() {
        if (this.impersonatedUser) {
            this.switchUserImpersonate(this.impersonatedUser);
        }
    }
}

